import type { SVGProps } from 'react';

export const SvgGuideTicket = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={80} height={73} viewBox="0 0 80 73" fill="none" {...props}>
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.326}
      d="M43.585 67.873.948 43.257 43.584 18.64l42.638 24.616z"
    />
    <path
      fill="url(#page-top__image-kabukatsu_svg__a)"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.326}
      d="M.948 47.557v-4.3l42.637 24.617v4.3z"
    />
    <path
      fill="url(#page-top__image-kabukatsu_svg__b)"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.326}
      d="M86.221 43.259v4.3L43.584 72.175v-4.3z"
    />
    <path
      fill="#FFC1C1"
      d="m30.919 21.871-4.602 2.68c2.084 1.207 2.093 3.155.025 4.355s-5.435 1.2-7.528 0l-4.602 2.68 24.924 14.383 16.706-9.714z"
    />
    <path
      fill="#fff"
      d="M55.842 36.255 39.136 45.97l9.884 5.707 4.602-2.68c-2.084-1.207-2.093-3.155-.026-4.354 2.076-1.208 5.445-1.208 7.529 0l4.602-2.68z"
    />
    <path
      stroke="#FF0019"
      strokeLinejoin="round"
      strokeWidth={1.326}
      d="m65.727 41.962-4.602 2.68c-2.084-1.208-5.453-1.208-7.528 0-2.076 1.208-2.059 3.155.025 4.355l-4.602 2.68-34.808-20.101 4.602-2.68c2.084 1.208 5.453 1.208 7.528 0 2.076-1.207 2.059-3.155-.025-4.355l4.602-2.68 34.8 20.093z"
    />
    <path
      fill="#FFC1C1"
      d="m30.919 16.47-4.602 2.679c2.084 1.208 2.093 3.156.025 4.355s-5.435 1.2-7.528 0l-4.602 2.68 24.924 14.384 16.706-9.715z"
    />
    <path
      fill="#fff"
      d="m55.842 30.863-16.706 9.714 9.884 5.708 4.602-2.68c-2.084-1.208-2.093-3.155-.026-4.355 2.076-1.208 5.445-1.208 7.529 0l4.602-2.68z"
    />
    <path
      stroke="#FF0019"
      strokeLinejoin="round"
      strokeWidth={1.326}
      d="m65.727 36.57-4.602 2.68c-2.084-1.209-5.453-1.209-7.528 0-2.076 1.207-2.059 3.155.025 4.354l-4.602 2.68-34.808-20.1 4.602-2.68c2.084 1.208 5.453 1.208 7.528 0 2.076-1.208 2.059-3.156-.025-4.355l4.602-2.68 34.8 20.092z"
    />
    <path
      fill="#FFC1C1"
      d="m30.919 11.077-4.602 2.68c2.084 1.207 2.093 3.155.025 4.354s-5.435 1.2-7.528 0l-4.602 2.68 24.924 14.384 16.706-9.714z"
    />
    <path
      fill="#fff"
      d="m55.842 25.47-16.706 9.715 9.884 5.707 4.602-2.68c-2.084-1.207-2.093-3.155-.026-4.354 2.076-1.208 5.445-1.208 7.529 0l4.602-2.68z"
    />
    <path
      stroke="#FF0019"
      strokeLinejoin="round"
      strokeWidth={1.326}
      d="m65.727 31.169-4.602 2.68c-2.084-1.209-5.453-1.209-7.528 0-2.076 1.207-2.059 3.155.025 4.354l-4.602 2.68L14.212 20.79l4.602-2.68c2.084 1.208 5.453 1.208 7.528 0 2.076-1.208 2.059-3.155-.025-4.355l4.602-2.68 34.8 20.093z"
    />
    <path
      fill="#FFC1C1"
      d="m30.919 5.684-4.602 2.68c2.084 1.207 2.093 3.155.025 4.355s-5.435 1.2-7.528 0l-4.602 2.68 24.924 14.384 16.706-9.715z"
    />
    <path
      fill="#fff"
      d="M55.842 20.067 39.136 29.78l9.884 5.708 4.602-2.68c-2.084-1.208-2.093-3.156-.026-4.355 2.076-1.208 5.445-1.208 7.529 0l4.602-2.68z"
    />
    <path
      stroke="#FF0019"
      strokeLinejoin="round"
      strokeWidth={1.326}
      d="m65.727 25.776-4.602 2.68c-2.084-1.208-5.453-1.208-7.528 0-2.076 1.207-2.059 3.155.025 4.355l-4.602 2.68-34.808-20.093 4.602-2.68c2.084 1.209 5.453 1.209 7.528 0 2.076-1.207 2.059-3.155-.025-4.354l4.602-2.68 34.8 20.092z"
    />
    <path
      fill="#FF0019"
      d="M54.95 21.436a.87.87 0 0 1-.74-.426.85.85 0 0 1 .306-1.165l.74-.425a.85.85 0 0 1 1.165.306.85.85 0 0 1-.306 1.165l-.74.426a.9.9 0 0 1-.426.119M42.969 28.402a.87.87 0 0 1-.74-.426.85.85 0 0 1 .306-1.165l1.327-.774a.85.85 0 0 1 1.165.306.85.85 0 0 1-.306 1.165l-1.327.774a.87.87 0 0 1-.425.12m3.99-2.323a.87.87 0 0 1-.74-.425.85.85 0 0 1 .305-1.165l1.327-.774a.85.85 0 0 1 1.166.306.85.85 0 0 1-.306 1.165l-1.328.774a.9.9 0 0 1-.425.12m3.997-2.322a.87.87 0 0 1-.74-.425.85.85 0 0 1 .306-1.166l1.327-.774a.85.85 0 0 1 1.166.306.85.85 0 0 1-.306 1.166l-1.328.774a.9.9 0 0 1-.425.119M39.578 30.376a.87.87 0 0 1-.74-.426.85.85 0 0 1 .307-1.165l.731-.425a.85.85 0 0 1 1.166.306.85.85 0 0 1-.307 1.165l-.731.425a.9.9 0 0 1-.426.12"
    />
    <defs>
      <linearGradient
        id="page-top__image-kabukatsu_svg__a"
        x1={23.132}
        x2={20.625}
        y1={56.24}
        y2={60.511}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A" />
        <stop offset={0.29} stopColor="#F5B3A4" />
        <stop offset={0.75} stopColor="#F9D2C8" />
        <stop offset={1} stopColor="#FBDED7" />
      </linearGradient>
      <linearGradient
        id="page-top__image-kabukatsu_svg__b"
        x1={65.026}
        x2={64.812}
        y1={75.255}
        y2={44.74}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A" />
        <stop offset={0.51} stopColor="#ED8B7D" />
        <stop offset={1} stopColor="#EB7D74" />
      </linearGradient>
    </defs>
  </svg>
);
